import React from "react";
import PostDetail from "../../components/Community/PostDetail";

export default function PraiseDetail() {
  return <PostDetail />;
}